module.exports = __webpack_public_path__ + "img/banner01.42208998.webp";